// Terminal foreground fast-path signal (knowledge/86 Task 1).
//
// A within-grace relay reconnect (#1377) is an authoritative instant repaint —
// but nothing tells a mounted TerminalView to reattach the moment the app
// returns to foreground, so the terminal waits out the ~10-25s ping-probe blind
// window before it repaints. This tiny reactive signal closes that gap: it is
// bumped SYNCHRONOUSLY inside onForeground() (app.svelte.ts) BEFORE the ping
// probe, and every mounted TerminalView observes it in a $effect that calls the
// already-idempotent reattachLive() (latched by #797, so a burst coalesces to a
// single re-subscribe — safe, no storm).
//
// Kept as a standalone module (mirrors foregroundSignal in core/state.svelte.ts)
// so TerminalView stays decoupled from the heavy app-state graph and the signal
// is trivially bumpable from tests. Direct signal, no wrapper class — respects
// the CLAUDE.md "no bridge/adapter" rule.
//
// P1 (this module) ships the fast-path on web/Android/desktop via the existing window
// focus/visibilitychange/online handlers that call onForeground(). P2 (optional, iOS)
// is a native Tauri `cyborg7://resume` emit from packages/mobile-cyborg's Rust entry
// point (WKWebView can miss `visibilitychange` on resume) + a JS listener calling
// onForeground(). Left as a follow-up: it lives outside packages/ui and needs the
// mobile run loop moved to the `build().run(callback)` form to hook `RunEvent::Resumed`
// — not a one-line emit. See knowledge/86 Task 1 "Native Tauri resume event (optional,
// iOS)".
export class TerminalForegroundSignalState {
  nonce = $state(0);
  bump(): void {
    this.nonce += 1;
  }
}

export const terminalForegroundSignal = new TerminalForegroundSignalState();
